<template>
  <div style="width: 100%; height: 100vh; overflow: auto">
    <div class="window-min-width">
      <platform-header
        title="品牌概览"
        :tabData="tabData"
        @tabChange="tabChange"
      />
      <div class="main-container">
        <div class="bottom-container">
          <div class="bottom-container-left">
            <card-official ref="cardOfficial"></card-official>
          </div>
          <div class="bottom-container-center">
            <card-region ref="cardRegion" @setPageTimer="setPageTimer"></card-region>
          </div>
          <div class="bottom-container-right" v-if="principal_id == ''">
            <div class="bottom-container-right-top">
              <card-brand-list ref="cardBrandList" @setPageTimer="setPageTimer"></card-brand-list>
            </div>
            <div class="bottom-container-right-bottom">
              <card-anchor-list ref="cardAnchorList"></card-anchor-list>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PlatformHeader from "@/components/PlatformTab/PlatformHeader";
import MyChart from "@/components/MyChart/MyChart";
import CardOfficial from "./components/CardOfficial";
import CardRegion from "./components/CardRegion";
import CardBrandList from "./components/CardBrandList";
import CardAnchorList from "./components/CardAnchorList";

export default {
  name: "brandSummary",
  components: {
    PlatformHeader,
    MyChart,
    CardOfficial,
    CardRegion,
    CardBrandList,
    CardAnchorList,
  },
  data() {
    return {
      msg: "品牌概览2",
      tabData: [
        {
          label: "抖音",
          value: "douyin",
        },
        {
          label: "快手",
          value: "kuaishou",
        },
      ],
      currentTab: "douyin",
      principal_id: "",
      dy_author_id: "",
      ks_author_id: "",
      dcd_author_id: "",
      pageRouterTimer: null,
    };
  },
  computed: {},
  created() {
    this.setPageTimer()
    console.log("本品概述入口", this.$route.query);
    this.$route.query.principal_id &&
      (this.principal_id = this.$route.query.principal_id);
    this.$route.query.dy_author_id &&
      (this.dy_author_id = this.$route.query.dy_author_id);
    this.$route.query.ks_author_id &&
      (this.ks_author_id = this.$route.query.ks_author_id);
    this.$route.query.dcd_author_id &&
      (this.dcd_author_id = this.$route.query.dcd_author_id);
  },
  watch: {},
  methods: {
    tabChange(val) {
      console.log("切换平台", val);
      this.currentTab = val;
      this.setPageTimer()
      this.initAllData();
    },
    initAllData() {
      this.$refs.cardOfficial.initData();
      this.$refs.cardRegion.initData();
      if (this.principal_id == "") {
        this.$refs.cardBrandList.initData();
        this.$refs.cardAnchorList.initData();
      }
    },
    // 重置定时器
    setPageTimer() {
      console.log('setPageTimer')
      clearTimeout(this.pageRouterTimer)
      this.pageRouterTimer = null;
      this.pageRouterTimer = setTimeout(() => {
        this.pageRouter();
      }, 1000 * 20);
    },
    // 定时路由跳转
    pageRouter() {
      clearTimeout(this.pageRouterTimer)
      this.pageRouterTimer = null;
      this.$router.push(`/bcPublicScreen/dealerOfOneself`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_handle.scss";
.window-min-width {
  min-width: 1440px;
}
.main-container {
  padding: 0 60px;
  .bottom-container {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    margin: 10px 0;
    &-left {
      @include background_color("background_color2");
      width: 388px;
      height: 896px;
      border-radius: 16px;
      overflow: hidden;
    }
    &-center {
      width: 984px;
      @include background_color("background_color2");
      height: 896px;
      border-radius: 16px;
      overflow: hidden;
    }
    &-right {
      width: 388px;
      height: 896px;
      &-top {
        width: 100%;
        height: 294px;
        border-radius: 16px;
        @include background_color("background_color2");
        margin-bottom: 20px;
        overflow: hidden;
      }
      &-bottom {
        width: 100%;
        height: 582px;
        border-radius: 16px;
        @include background_color("background_color2");
        overflow: hidden;
      }
    }
  }
}
.fw {
  font-weight: bold;
}
.f12 {
  font-size: 12px;
}
.f14 {
  font-size: 14px;
}
.f16 {
  font-size: 16px;
}
.f18 {
  font-size: 18px;
}
</style>
